import { API_BASE, getAuthHeaders, fetchJson } from './client';

export const file = {
  upload: async (file: File, projectId?: string): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    if (projectId) formData.append('projectId', projectId);
    const authHeaders = await getAuthHeaders();
    const res = await fetch(`${API_BASE}/files/upload`, {
      method: 'POST',
      headers: { ...authHeaders },
      body: formData,
    });
    if (!res.ok) throw new Error('Upload failed');
    return res.json();
  },
  readBinary: async (filePath: string): Promise<ArrayBuffer> => {
    const authHeaders = await getAuthHeaders();
    if (filePath.startsWith('/api/')) {
      const res = await fetch(filePath, { headers: authHeaders });
      if (!res.ok) throw new Error('Failed to read file');
      return res.arrayBuffer();
    }
    const res = await fetch(`${API_BASE}/files/read-binary`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...authHeaders },
      body: JSON.stringify({ filePath }),
    });
    if (!res.ok) throw new Error('Failed to read file');
    return res.arrayBuffer();
  },
  serve: (fileId: string) => `${API_BASE}/files/${fileId}/serve`,
  binary: (fileId: string) => `${API_BASE}/files/${fileId}/binary`,
  exists: async (filePath: string) => {
    try {
      const res = await fetch(`${API_BASE}/files/read-binary`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ filePath }),
      });
      return res.ok;
    } catch { return false; }
  },
  getMetadata: (fileId: string) => fetchJson<any>(`/files/${fileId}/metadata`),
  list: (projectId: string, assetType?: string) =>
    fetchJson<any[]>(`/files?projectId=${projectId}${assetType ? `&assetType=${assetType}` : ''}`),
  delete: (fileId: string) => fetchJson<any>(`/files/${fileId}`, { method: 'DELETE' }),
};
